// Convenience for callers that bypass the shared axios instance (customHTTP.js) and therefore
// have to attach the bearer token themselves: bare fetch()/XHR calls and three.js loaders.
// customHTTP.js keeps its own copy of this logic in its request interceptor; this is not a
// replacement for that, just the same token for callers that never go through axios.
export const authHeader = () => {
    try {
        const token = localStorage.getItem("token");
        return token ? { Authorization: `Bearer ${token}` } : {};
    } catch (error) {
        return {};
    }
};
